import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { useRelations } from '@hooks/useUser'

import { UserModel } from '@models/types'

interface SupportUserListItemProps {
  callbacks: {
    toggleSupportUserId: () => void,
  },
  user: UserModel,
}

const SupportUserListItem = (props: SupportUserListItemProps) => {
  const {
    callbacks: {
      toggleSupportUserId,
    },
    user,
  } = props

  const { full_name } = user

  const {
    role: {
      // @ts-expect-error TS2339
      title: roleTitle,
    },
  } = useRelations(user)

  return (
    <DashboardModuleListItem
      boxProps={{ paddingX: 0 }}
      secondaryText={roleTitle}
      title={full_name}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon onClick={() => toggleSupportUserId()} type="delete" />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default SupportUserListItem
